<template>
  <div class="page">
    <img src="https://img.shengdeduo.com.cn/weapp/customer-enterprise.jpg" />
  </div>
</template>
<script>
export default {
  name: 'job',
  data () {
    return {
    }
  }
}
</script>

<style lang="less" scoped>

.page {
  max-width: 750px;
  margin: 0 auto;
  background: #fff;
  min-height: 100vh;
}
img {
  max-width: 100%;
}
</style>
